import React, { Component } from "react";
import axios from "axios";
import { Form, Col, Row } from "react-bootstrap";
import * as apiMethods from "../res/apiMethods.js";

import Sidebar from "../components/Sidebar";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clientes: [],
      creditos: [],
      transacciones: [],
      clientesData: [],
      creditosData: [],
      transaccionesData: [],
    };
  }

  componentDidMount() {
    document.title = "Inicio";
    let actUsrToken = window.sessionStorage.getItem("localToken");

    axios
      .get(apiMethods.GET_CREDITO_ALL, {
        headers: {
          Authorization: actUsrToken,
        },
      })
      .then((response) => {
        const creditos = response.data.credits || [];
        const todasTransacciones = [];
        creditos.forEach(credito => {
          if (credito.transacciones && Array.isArray(credito.transacciones)) {
            const transaccionesConCredito = credito.transacciones.map(tx => ({
              ...tx,
              credito: credito.id 
            }));
            todasTransacciones.push(...transaccionesConCredito);
          }
        });

        const todosClientes = [];
        creditos.forEach(credito => {
          if (credito.deudores && Array.isArray(credito.deudores)) {
            todosClientes.push(...credito.deudores);
          }
        });
        this.setState({
          creditosData: creditos,
          transaccionesData: todasTransacciones,
          clientesData: todosClientes,
        });
      })
  }
  
  componentDidUpdate = () => {};

  login = () => {
    this.props.window.location.href = "/login";
  };

  renderTableDataClientes() {
    return this.state.clientesData.map((clientesData, index) => {
      const { tipoDocumento, nombre, documento } = clientesData;
      return (
        <tr key={documento}>
          <td>{tipoDocumento}</td>
          <td>{nombre}</td>
          <td>{documento}</td>
        </tr>
      );
    });
  }

  renderTableHeaderClientes() {
    let header = ["Tipo Documento", "Nombre", "Documento"];
    return header.map((key, index) => {
      return <th key={index}>{key.toUpperCase()}</th>;
    });
  }

  renderTableHeaderCreditos() {
    let header = ["Credito","Saldo", "Plazo"];
    return header.map((key, index) => {
      return <th key={index}>{key.toUpperCase()}</th>;
    });
  }

  //new Date(element.fechaTx).getMonth() < (new Date().getMonth()-2)
  renderTableDataCreditos() {
    const formatearMonto = (valor) => {
      const numero = typeof valor === 'string' ? parseFloat(valor.replace(/,/g, '')) : valor;
      return `$${numero.toLocaleString('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
    };

    return this.state.creditosData
      .filter((credito) => {
        const capital = typeof credito.vlrCapital === 'string' 
          ? parseFloat(credito.vlrCapital.replace(/,/g, ''))
          : credito.vlrCapital;
        
        return capital > 0;
      })
      .map((creditosData) => {
        const { id, vlrCapital, plazo } = creditosData;
        const montoFormateado = formatearMonto(vlrCapital);
        
        return (
          <tr key={id}>
            <td>{id}</td>
            <td>{montoFormateado}</td>
            <td>{plazo}</td>
          </tr>
        );
      });
  }
  
  renderTableDataPagos() {
    // Función para formatear fecha "2021-02-08T00:00:00.000Z" a "8-FEB-2021"
    const formatearFecha = (fechaISO) => {
      const meses = ['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC'];
      
      const fecha = new Date(fechaISO);
      const dia = fecha.getDate();
      const mes = meses[fecha.getMonth()];
      const anio = fecha.getFullYear();
      
      return `${dia}-${mes}-${anio}`;
    };

    // Función para formatear monto con $ y separadores de miles
    const formatearMonto = (valor) => {
      const numero = typeof valor === 'string' ? parseFloat(valor.replace(/,/g, '')) : valor;
      return `$${numero.toLocaleString('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
    };

    // Agrupar transacciones por crédito
    const transaccionesPorCredito = this.state.transaccionesData.reduce((acc, transaccion) => {
      const { credito } = transaccion;
      
      if (!acc[credito]) {
        acc[credito] = [];
      }
      acc[credito].push(transaccion);
      
      return acc;
    }, {});

    // Obtener el último pago diferente a 0 de cada crédito
    const ultimosPagos = [];
    Object.values(transaccionesPorCredito).forEach(transacciones => {
      // Filtrar los que son diferentes a 0
      const transaccionesValidas = transacciones.filter(t => t.vlrTx !== 0 && t.vlrTx !== '0');
      
      if (transaccionesValidas.length > 0) {
        // Ordenar por fecha descendente y tomar el primero
        const ultimoPagoValido = transaccionesValidas
          .sort((a, b) => new Date(b.fechaTx) - new Date(a.fechaTx))[0];
        
        ultimosPagos.push(ultimoPagoValido);
      }
    });

    // Ordenar todos los pagos por fecha descendente (más recientes primero)
    const pagosOrdenados = ultimosPagos.sort((a, b) => {
      return new Date(b.fechaTx) - new Date(a.fechaTx);
    });

    // Renderizar
    return pagosOrdenados.map((transaccion) => {
      const { id, credito, vlrTx, fechaTx } = transaccion;
      
      // Formatear la fecha y el monto
      const fechaFormateada = formatearFecha(fechaTx);
      const montoFormateado = formatearMonto(vlrTx);
      
      return (
        <tr key={id}>
          <td>{credito}</td>
          <td>{montoFormateado}</td>
          <td>{fechaFormateada}</td>
        </tr>
      );
    });
  }
  
  renderTableHeaderPagos() {
    let header = ["Credito", "Monto", "Fecha Pago"];
    return header.map((key, index) => {
      return <th key={index}>{key.toUpperCase()}</th>;
    });
  }

  render = () => {
    let actUsrToken = window.sessionStorage.getItem("localToken");
    if (actUsrToken !== undefined) {
      let decodedPayload = JSON.parse(atob(actUsrToken.split(".")[1]));
      if (decodedPayload.roleId === 1 || decodedPayload.roleId === 2) {
        return (
          <React.Fragment>
            <div style={{ display: "grid", gridTemplateColumns: "15% 85%" }}>
              <Sidebar />
              <div className="cardDashboard" style={{width: "100%", marginLeft:"16%"}}>
                <Form>
                  <Row>
                    <Col>
                      <Form.Label className="headDashboard">
                        Créditos
                      </Form.Label>{" "}
                      <br></br>
                      <div>
                        <table id="table">
                          <tbody>
                            <tr>{this.renderTableHeaderCreditos()}</tr>
                            {this.renderTableDataCreditos()}
                          </tbody>
                        </table>
                      </div>
                    </Col>
                    <Col>
                      <Form.Label className="headDashboard">Pagos</Form.Label>{" "}
                      <br></br>
                      <div>
                        <table id="table">
                          <tbody>
                            <tr>{this.renderTableHeaderPagos()}</tr>
                            {this.renderTableDataPagos()}
                          </tbody>
                        </table>
                      </div>
                    </Col>
                    <Col></Col>
                  </Row>
                </Form>
              </div>
            </div>
          </React.Fragment>
        );
      } else if (decodedPayload.roleId === 3 || decodedPayload.roleId === 4) {
        return (
          <React.Fragment>
            <div className="cardDashboard">
              <Form>
                <Row>
                  <Col>
                    <Form.Label className="headDashboard">Clientes</Form.Label>{" "}
                    <br></br>
                    <div>
                      <table id="table">
                        <tbody>
                          <tr>{this.renderTableHeaderClientes()}</tr>
                          {this.renderTableDataClientes()}
                        </tbody>
                      </table>
                    </div>
                  </Col>
                  <Col>
                    <Form.Label className="headDashboard">Créditos</Form.Label>{" "}
                    <br></br>
                    <div>
                      <table id="table">
                        <tbody>
                          <tr>{this.renderTableHeaderCreditos()}</tr>
                          {this.renderTableDataCreditos()}
                        </tbody>
                      </table>
                    </div>
                  </Col>
                  <Col>
                    <Form.Label className="headDashboard">Pagos</Form.Label>{" "}
                    <br></br>
                    <div>
                      <table id="table">
                        <tbody>
                          <tr>{this.renderTableHeaderPagos()}</tr>
                          {this.renderTableDataPagos()}
                        </tbody>
                      </table>
                    </div>
                  </Col>
                </Row>
              </Form>
            </div>
          </React.Fragment>
        );
      } else {
        return (
          <React.Fragment>
            <p className="cover">Bienvenido</p>
            <p id="userLogged"></p>
          </React.Fragment>
        );
      }
    }
  };
}

export default Home;
